import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";

import RepeatIcon from "@material-ui/icons/Repeat";

import {
  FormControl,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";

import "./inputs.styles.scss";

// //depending on the current tab these should change
// const input_values = [
//   {
//     category: 'Relateable Quantity Equivalent',
//     name: '12V car battery charge',
//     rowkey: '12v_car_battery_charge',
//   },
//   {
//     category: 'Relateable Quantity Equivalent',
//     name: '9V square battery charge',
//     rowkey: '9v_square_battery_charge',
//   },
//   {
//     category: 'Relateable Quantity Equivalent',
//     name: 'Boiling a kettle',
//     rowkey: 'boiling_a_kettle',
//   },
//   { category: 'Imperial Unit', name: 'BTU', rowkey: 'btu' },
//   {
//     category: 'Relateable Quantity Equivalent',
//     name: 'g TNT Equiv',
//     rowkey: 'g_tnt_equiv',
//   },
//   { category: 'Imperial Unit', name: 'kcal', rowkey: 'kcal' },
//   {
//     category: 'Gas Quantity Equivalent',
//     name: 'kg hydrogen',
//     rowkey: 'kg_hydrogen',
//   },
//   { category: 'SI Unit', name: 'kJ', rowkey: 'kj' },
//   { category: 'Derived Unit', name: 'kWh', rowkey: 'kwh' },
//   { category: 'SI Unit', name: 'MJ', rowkey: 'mj' },
//   { category: 'Imperial Unit', name: 'mmBTU', rowkey: 'mmbtu' },
//   { category: 'Derived Unit', name: 'MWh', rowkey: 'mwh' },
//   {
//     category: 'Gas Quantity Equivalent',
//     name: 'Nm\u00b3 biogas',
//     rowkey: 'nm_cb_biogas',
//   },
//   {
//     category: 'Gas Quantity Equivalent',
//     name: 'Nm\u00b3 hydrogen',
//     rowkey: 'nm_cb_hydrogen',
//   },
//   {
//     category: 'Gas Quantity Equivalent',
//     name: 'Nm\u00b3 natural gas',
//     rowkey: 'nm_cb_natural_gas',
//   },
//   {
//     category: 'Relateable Quantity Equivalent',
//     name: 'Tesla Model S charge',
//     rowkey: 'tesla_model_s_charge',
//   },
//   {
//     category: 'Relateable Quantity Equivalent',
//     name: 'Tesla Powerwall 2 charge',
//     rowkey: 'tesla_powerwall_2_charge',
//   },
//   {
//     category: 'Relateable Quantity Equivalent',
//     name: 'UK home annual elec use',
//     rowkey: 'uk_home_annual_elec_use',
//   },
//   {
//     category: 'Relateable Quantity Equivalent',
//     name: 'UK home daily elec use',
//     rowkey: 'uk_home_daily_elec_use',
//   },
//   { category: 'Imperial Unit', name: 'US Therm', rowkey: 'us_therm' },
//   {
//     category: 'Relateable Quantity Equivalent',
//     name: 'Weetabix',
//     rowkey: 'weetabix',
//   },
// ];

// const categories = [...new Set(input_values.map((x) => x.category))];

// let menuItems = [];

// function get_units_for_category(category) {
//   const units = [];
//   input_values.forEach((element) => {
//     if (element.category === category) {
//       units.push(element.name);
//     }
//   });
//   return units;
// }

// let counter = 0;
// categories.forEach((category) => {
//   menuItems.push(<ListSubheader>{category}</ListSubheader>);
//   get_units_for_category(category).forEach((unit) => {
//     menuItems.push(<MenuItem value={counter}>{unit}</MenuItem>);
//   });
//   counter++;
// });

// //each time the input change the output should be evaluated
// let inputValue = 1;
// let outputValue = inputValue * 2;

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
    maxWidth: 800,
    border: "1px solid #3c8dbc",
    margin: "auto",
    padding: "20px 0",
    marginBottom: 30,
  },
  title: {
    fontWeight: "bold",
  },
  pos: {
    marginBottom: 30,
  },
  card: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function OutlinedCard({ units, fromChange, inputChange }) {
  const classes = useStyles();

  const [inputsValues, setInputsValues] = useState({
    inputValue: "1",
    fromValue: "",
    toValue: "",
  });

  const [outputValue, setOutputValue] = useState("1");

  const onChange = ({ target }) => {
    setInputsValues({
      ...inputsValues,
      [target.name]: target.value,
    });
  };

  useEffect(() => {
    // console.log(inputsValues);
    if (inputsValues.fromValue && inputsValues.toValue) {
      let conversionRate1 = units.filter(
        (item) => item.name === inputsValues.fromValue
      )[0];
      let conversionRate2 = units.filter(
        (item) => item.name === inputsValues.toValue
      )[0];

      setOutputValue(
        Number(
          (
            (inputsValues.inputValue * conversionRate2.conversion) /
            conversionRate1.conversion
          ).toPrecision(8)
        )
      );
    }
  }, [inputsValues, units]);

  const onClick = () => {
    if (inputsValues.fromValue && inputsValues.toValue) {
      let value1 = inputsValues.fromValue;
      let value2 = inputsValues.toValue;

      setInputsValues({
        ...inputsValues,
        fromValue: value2,
        toValue: value1,
      });
    }
  };

  const { inputValue, fromValue, toValue } = inputsValues;

  return (
    <Card className={classes.root} variant="outlined">
      <CardActions className={classes.card}>
        <div className={classes.pos}>
          <TextField
            value={inputValue}
            type="number"
            label="Input"
            name="inputValue"
            onChange={onChange}
            onInput={inputChange(inputValue)}
          />
        </div>
        <div className="inputs-block">
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="from-select" shrink>
              From
            </InputLabel>
            <Select
              value={fromValue}
              name="fromValue"
              id="grouped-select"
              onChange={onChange}
              onSelect={fromChange(fromValue)}
            >
              {units.map(({ name, category, conversion }, index) => (
                <MenuItem value={name} key={index}>
                  {name}
                </MenuItem>
              ))}
              {/* <ListSubheader>Category 1</ListSubheader>
              <MenuItem value={1}>Option 1</MenuItem>
              <MenuItem value={2}>Option 2</MenuItem>
              <ListSubheader>Category 2</ListSubheader>
              <MenuItem value={3}>Option 3</MenuItem>
              <MenuItem value={4}>Option 4</MenuItem> */}
            </Select>
          </FormControl>
          <Button
            size="large"
            variant="contained"
            color="primary"
            className="inputs-button"
            onClick={onClick}
          >
            <RepeatIcon />
          </Button>
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="from-select" shrink>
              To
            </InputLabel>
            <Select
              value={toValue}
              id="grouped-select"
              name="toValue"
              onChange={onChange}
            >
              {units.map(({ name, category, conversion }, index) => (
                <MenuItem value={name} key={index}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <TextField
          value={outputValue}
          type="number"
          label="Answer"
          inputProps={{ readOnly: true }}
          InputLabelProps={{ shrink: true }}
        />
      </CardActions>
    </Card>
  );
}
